import { WagoApiClient } from '@shared/service/wago-api.client';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class TicketService {
  private readonly getNextTicketIdUrl: string = 'ticket/next';
  private readonly SUPPORT_EMAIL_TICKET_NAME: string = 'supportEmail';

  constructor(private wagoApiClient: WagoApiClient) {}

  public getSupportEmailTicketId(): Observable<number> {
    return this.getTicketIdByName(this.SUPPORT_EMAIL_TICKET_NAME);
  }

  private getTicketIdByName(ticketName: string): Observable<number> {
    return this.wagoApiClient.get(`${this.getNextTicketIdUrl}/?name=${ticketName}`);
  }
}
